import { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { getTokenSii } from '../utils/getTokenSii';
import { apiSettings } from '../utils/ApiSettings';

export const useGetExpedient = (setComerciante, setSnackbar) => {

    const [isLoading, setIsLoading] = useState(false);
    const { handleSubmit, errors, control, reset } = useForm();
    
    const onSubmit = async (data) => {
        setIsLoading(true);
        const token = await getTokenSii();
        handleBusquedaExpedientes(token, data.id);
    }

    const handleBusquedaExpedientes = async (token, id) => {
        const { uri, credentials } = apiSettings;
        credentials.token = token;
        credentials.matriculainicial = '';
        credentials.nombreinicial = '';
        credentials.identificacion = id;
        credentials.semilla = 0

        try {
            const response = await fetch(`${uri}busquedaExpedientes`,  {
                method: 'POST',
                body: JSON.stringify(credentials)
            });

            if(response.ok) {
                const data = await response.json();

                if(data.codigoerror === '0000') {
                    if(data.total > 0) {
                        if(data.expedientes[0].ultanorenovado === (new Date().getFullYear()-1).toString()) {
                            handleConsultarExpedienteMercantil(token, data.expedientes[0]);
                        }else {
                            setSnackbar(e => ({...e, visible: true, message: `El registro debe tener como último año renovado el ${ (new Date().getFullYear() -1) }` }));
                            setIsLoading(false);
                        }
                    }else {
                        setSnackbar(e => ({...e, visible: true, message: 'No se obtuvo ningún resultado.'}));
                        setIsLoading(false);
                        return false;
                    }
                }else {
                    setSnackbar(e => ({...e, visible: true, message: 'No se obtuvo ningún resultado.'}));
                    setIsLoading(false);
                    return false;
                }
            }
        }catch(e) {
            return false;
        }
    }

    const handleConsultarExpedienteMercantil = async (token, info) => {
        const { uri, credentials } = apiSettings;
        credentials.token = token;
        credentials.matricula = "";
        credentials.identificacion = info.identificacion;
        credentials.tipo = "A";

        try {
            const response = await fetch(`${uri}consultarExpedienteMercantil`, {
                method: 'POST',
                body: JSON.stringify(credentials)
            });

            if (response.ok) {
                const data = await response.json();

                if (data.codigoerror === '0000') {
                    if (data.ultanorenovado === (new Date().getFullYear()-1).toString()) {
                        setComerciante({ type: 'add', payload: { busquedaExpediente: info , consultarExpediente: data } });               
                        setIsLoading(false);
                        reset({id: ''});
                    } else {
                        setIsLoading(false);
                    }
                } else {
                    setIsLoading(false);
                    return false;
                }
            }
        } catch (e) {
            return false;
        }
    }

    return {
        onSubmit,
        isLoading,
        Controller,
        handleSubmit,
        errors,
        control
    }
}